import {
    Avatar,
    Box,
    Button,
    Checkbox,
    Dialog,
    Divider,
    FormControlLabel,
    Grid,
    IconButton,
    Link as MuiLink,
    Stack,
    Tooltip,
    Typography,
  } from "@mui/material";
  import React, {useState} from "react";
  import CloseIcon from "@mui/icons-material/Close";
  import ArrowBackIcon from "@mui/icons-material/ArrowBack";
  import InvoicesPanel from "../../pages/crm/pos/invoices/Invoices";
  import ribbon from "../../assets/images/ribbon.svg";
  import redRibbon from "../../assets/images/red-badg.svg";
import ribbonorange from "../../assets/images/ribbon-orange.svg";
  import CustomButtoncolor from "../../components/custom-button/customColorButton";
  import moment from "moment";
  import {redirect, useLocation, useNavigate} from "react-router";
  import {AppointmentAllStatusArray, MySwal, successConfirmation} from "../../services/utills";
  import AppointmentStaffStatus from "../../pages/crm/appointment/AppointmentStaffStatus/appointmentStaffStatus";
  import AppointmentReschedule from "./AppointmentReschedule";
  import {Link} from "react-router-dom";
  import CheckIcon from '@mui/icons-material/Check';
  import TreatmentFormButton from "./treatmentForm";
  import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
  import AppointmentRescheduleDate from "./AppointRescheduleDate";
import SetEmailModal from "../modal/SetEmailModal";
import BrandAvatar from "../avatar/BrandAvatar";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import EmailIcon from '@mui/icons-material/Email';
import AppointmentRescheduleDateTime from "./AppointmentDateResecudule";
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import UpdateIcon from '@mui/icons-material/Update';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import HistoryIcon from '@mui/icons-material/History';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

  export const outercontainer = {
    marginBottom: "16px",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    border: "1px solid #F0CDDB",
    borderRadius: "14px",
    overflow: "hidden",
    '@media (max-width: 600px) ': {
       position:'relative'
    },
  };
  export const bookingwrapper = {
    display: 'flex',
    flexDirection:{sm:'row' ,xs:'column'},
    justifyContent: "space-between",
  };
  export const ribbonwrapper = {
    display: "flex",
    alignItems:'flex-start',
    width:'fit-content',
    gap: "8ppx",

  };

  export const wallet = {
    display: "flex",
    alignItems:'center',
    marginTop: "8%",
    gap: "6px",
    '@media (max-width: 470px)' :{
        marginTop: "3%",
      },
  };

  export const boxwrapper = {
    border: "1px solid black",
    padding: "10px",
    height: "13vh",
    alignItems: "center",
    textAlign: "center",
    borderRadius: "8px",
    '@media (min-width:1200px) and (max-width: 1330px) ': {
        marginLeft:'10px',
    }
  };
  export const box = {
    display: "block",
    margin: "15px auto",
    '@media (max-width: 600px) ': {
        margin: "5px auto",
    }

  };

  export const status = {
    alignItems: "center",
    display: "flex",
    gap: "25px",
  };
  export const bookingtext = {
    display: "flex",
    flexDirection: "column",
  };
  export const datacolor = {
    color: "#2F80ED",

  };
  export const content = {
    fontFamily:"helvetica-lt-std-bold",
    fontSize: "13px",
    color: "#000000",
    fontWeight: "400",
    overflowWrap:"anywhere"

  };
  export const heading = {
    fontSize: "18px",
    color: "#000",
    fontWeight: "400",
  };
  export const textul = {
    color: "#000000",
    fontSize: "25px",
    fontWeight: "700",
    '@media (max-width: 600px)':{
        fontSize: "20px",
    }
  };

  export const email = {
    fontsize: "15px",
  };
  export const btnwrapper = {
    marginTop:'14px',
    display: "flex",
    alignItems:'center',
    marginLeft:'8px',
    gap:'15px',
    flexWrap:'wrap',
  };
  export const stylebtn = {
    borderRadius: "4px",
    padding: '10px 14px',
    height:'fit-content',
    '@media (max-width: 450px)': {
        fontSize:'18px',
        width:'100%'
    },
  };
export const buttonStyle = {
    padding: '10px 8px',
    // Add other styles here
};
export const mySwalButtonCancel = {
    backgroundColor: "#f44336",
    color: "#fff",
    width: { xs: '100%', sm: '150px' }, // uniform width
    border: "1px solid #f44336",
    borderRadius: '10px',
    fontSize: '16px',
    px: 0, // remove horizontal padding if needed
    "&:hover": {
      backgroundColor: "#d32f2f",
      border: "1px solid #d32f2f",
    },
  };

  export const mySwalButtonYes = {
    backgroundColor: "#27AE60",
    color: "#fff",
    width: { xs: '100%', sm: '150px' },
    border: "1px solid #27AE60",
    borderRadius: '10px',
    fontSize: '16px',
    px: 0,
    "&:hover": {
      backgroundColor: "#219653",
      border: "1px solid #219653",
    },
  };

export const mySwalButton ={
    backgroundColor: "#fff",
    minWidth: "max-content",
    border: "1px solid #666666",
    borderRadius: '10px',
    fontSize: '16px',
    px: '20px',
    mx: '10px',
    color: "#666666",
    "&:hover": {
      backgroundColor: "#fff",
      border: "1px solid #666666",
    },
  }
  export const handleEditReschedule = async (redirect,appointment) => {
    redirect(`/crm/appointment/reschedule/edit/${appointment?.id}`)
  }

  // Wrapper that renders any button/component as a white outlined chip with a
  // colored border + label (matches the appointment-details quick-actions style).
  const iconActionWrap = (color) => ({
    '& .MuiButton-root, & .MuiIconButton-root': {
      minWidth: 'auto !important',
      width: { xs: '100%', sm: 'auto' },
      justifyContent: 'center',
      boxSizing: 'border-box',
      height: '38px',
      borderRadius: '10px !important',
      padding: '6px 16px !important',
      border: `1.5px solid ${color} !important`,
      backgroundColor: '#fff !important',
      color: `${color} !important`,
      textTransform: 'capitalize',
      fontSize: '13px',
      fontWeight: 600,
      lineHeight: { xs: 1.2, sm: 1 },
      whiteSpace: { xs: 'normal', sm: 'nowrap' },
      boxShadow: 'none',
      transition: 'all 0.15s ease',
      '& .MuiButton-startIcon': { margin: '0 6px 0 0', color: color },
      '& .MuiButton-startIcon svg, & svg': { fontSize: '17px', color: color },
      '&:hover': {
        backgroundColor: `${color}10 !important`,
        color: `${color} !important`,
        borderColor: `${color} !important`,
        boxShadow: `0 2px 8px ${color}33`,
        '& .MuiButton-startIcon, & .MuiButton-startIcon svg, & svg': { color: color },
      },
    },
  });

  const IconAction = ({ tooltip, color = '#A72C68', children, sx }) => (
    <Tooltip title={tooltip} placement="top" arrow>
      <Box sx={{ ...iconActionWrap(color), display: { xs: 'block', sm: 'inline-flex' }, width: { xs: '100%', sm: 'auto' }, ...sx }}>
        {children}
      </Box>
    </Tooltip>
  );

  const CardAppointment = ({appointment,index,fetchAppointment}) => {
      const navigate = useNavigate()


       const [showAll, setShowAll] = useState(false);
       const [invoicePanelBookingId, setInvoicePanelBookingId] = useState(null);
  const services = appointment?.services || [];

  const visibleServices = showAll ? services : services.slice(0, 2);
      const { pathname } = useLocation();
      const handleAppointmentClick = (url) => {
          navigate(url)
      }
      const openInvoicePanel = (bookingId) => {
          if (bookingId) setInvoicePanelBookingId(bookingId);
      }
      const handleClick = (itemId) => {
        navigate(`/crm/customer-relationship-management`, {
          state: { value: itemId, },
        })
    };

    const [expanded, setExpanded] = useState(false);


    const handleToggleExpand = () => {
      setExpanded(!expanded);
    };

    const MAX_LENGTH = 30;

    const initials = (appointment?.customer?.name || '?')
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((s) => s.charAt(0).toUpperCase())
        .join('') || '?';

    const isPaid = appointment?.payment_status === 'Paid' || appointment?.payment_status === 'Pre Paid';
    const invoiceId = appointment?.invoices?.invoices_methods?.[0]?.id;

    // Section label style (uppercase grey heading at the top of each column)
    const sectionLabel = {
      fontSize: '11px',
      fontWeight: 700,
      letterSpacing: '0.08em',
      color: '#1a1a2e',
      mb: 1.25,
      textTransform: 'uppercase',
      fontFamily: 'helvetica-lt-std-bold,sans-serif',
    };

      return (
        <Box sx={outercontainer}>
          {/* ── Pink header strip ─────────────────────────────────────────────── */}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 1.5,
            px: { xs: 1.5, sm: 2.5 },
            py: 1.25,
            background: '#FAEFF5',
            borderBottom: '1px solid #F0CDDB',
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 1.5 }, flexWrap: 'wrap' }}>
              <Box sx={{ background: '#fff', borderRadius: '8px', px: 1.25, py: 0.5, border: '1px solid #F0CDDB' }}>
                <Typography component="span" sx={{ fontSize: '12px', fontWeight: 600, color: '#1a1a2e' }}>Booking</Typography>
                <Typography component="span" sx={{ fontSize: '13px', fontWeight: 700, color: '#A72C68', ml: 0.75 }}>#{appointment?.id}</Typography>
              </Box>
              {invoiceId && (
                <Box sx={{ background: '#fff', borderRadius: '8px', px: 1.25, py: 0.5, border: '1px solid #F0CDDB', cursor: 'pointer' }}
                     onClick={() => openInvoicePanel(appointment?.id)}>
                  <Typography component="span" sx={{ fontSize: '12px', fontWeight: 600, color: '#1a1a2e' }}>Invoice</Typography>
                  <Typography component="span" sx={{ fontSize: '13px', fontWeight: 700, color: '#A72C68', ml: 0.75 }}>#{invoiceId}</Typography>
                </Box>
              )}
              {appointment?.customer?.customer_batch && appointment?.customer?.customer_batch !== "New User" && (
                <Box sx={ribbonwrapper}>
                  {appointment?.customer?.customer_batch.includes("Expire/Cancel") ? (
                    <>
                      <img style={{ marginTop: '4px' }} src={redRibbon} alt={'member'} />
                      <Typography style={{ color: "#FF0000", fontSize: '12px' }}>{appointment?.customer?.customer_batch}</Typography>
                    </>
                  ) : appointment?.customer?.customer_batch.includes("Declined") ? (
                    <>
                      <img style={{ marginTop: "4px", width: "20px" }} src={ribbonorange} alt={'member'} />
                      <Typography style={{ color: "#f55d0b", fontSize: '12px' }}>{appointment?.customer?.customer_batch}</Typography>
                    </>
                  ) : (
                    <>
                      <img style={{ marginTop: '4px' }} src={ribbon} alt={'member'} />
                      <Typography style={{ color: "#219653", fontSize: '12px' }}>{appointment?.customer?.customer_batch}</Typography>
                    </>
                  )}
                </Box>
              )}
              {appointment?.customer?.customer_batch === "New User" && (
                <Typography style={{ color: "#09ABF1", fontSize: '12px' }}>{appointment?.customer?.customer_batch}</Typography>
              )}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
              {appointment?.status && (
                <Box sx={{
                  background: appointment?.status_color ? `${appointment.status_color}22` : '#FEF3C7',
                  color: appointment?.status_color || '#92400E',
                  border: `1px solid ${appointment?.status_color || '#FBBF24'}`,
                  borderRadius: '999px',
                  px: 1.5, py: 0.4,
                  fontSize: '12px', fontWeight: 700,
                  whiteSpace: 'nowrap',
                }}>
                  {AppointmentAllStatusArray[appointment?.status] || appointment?.status}
                </Box>
              )}
              <Typography sx={{
                fontSize: '13px',
                fontWeight: 700,
                color: isPaid ? '#219653' : '#EB5757',
              }}>
                {appointment?.payment_status}
              </Typography>
            </Box>
          </Box>

          {/* ── Body grid: CUSTOMER / SERVICES / SCHEDULE / AMOUNT ────────────── */}
          <Box sx={{ p: { xs: 1.5, sm: 2.5 } }}>
            <Grid container spacing={{ xs: 2, sm: 2.5 }}>
              {/* CUSTOMER */}
              <Grid item xs={12} sm={6} md={3}>
                <Typography sx={sectionLabel}>CUSTOMER</Typography>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                  <BrandAvatar
                      name={appointment?.customer?.name}
                      src={appointment?.customer?.profile_image}
                      size={44}
                  />
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                        sx={{
                          fontSize: '15px', fontWeight: 700,
                          color: '#1a1a2e', textTransform: 'capitalize',
                          cursor: 'pointer', lineHeight: 1.25,
                          fontFamily: 'helvetica-lt-std-bold,sans-serif',
                        }}
                        onClick={() => handleClick(appointment?.customer?.name)}
                    >
                      {appointment?.customer?.name}
                    </Typography>
                    <Box sx={{
                      display: 'inline-flex', alignItems: 'center',
                      background: appointment?.status_color || '#A72C68',
                      color: '#fff',
                      borderRadius: '6px', px: 0.75, py: 0.25,
                      mt: 0.5, fontSize: '10px', fontWeight: 700, letterSpacing: '0.04em',
                    }}>
                      MEMBER · ID {appointment?.customer?.id}
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ mt: 1.25 }}>
                  <Typography
                      component="a"
                      href={`tel:${appointment?.customer?.phone}`}
                      sx={{ display: 'block', fontSize: '13px', color: '#1a1a2e', textDecoration: 'none', mb: 0.25 }}
                  >
                    {appointment?.customer?.phone}
                  </Typography>
                  <Typography
                      component="a"
                      href={`mailto:${appointment?.customer?.email}`}
                      sx={{ display: 'block', fontSize: '13px', color: '#1a1a2e', textDecoration: 'none', wordBreak: 'break-all' }}
                  >
                    {appointment?.customer?.email}
                  </Typography>
                </Box>
                {appointment?.appointment_customer_note && typeof appointment.appointment_customer_note === 'object' && appointment.appointment_customer_note !== null && (
                  <Box sx={{ mt: 1 }}>
                    <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#1a1a2e', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                      Appointment Notes
                    </Typography>
                    <Typography
                        sx={{ fontSize: '13px', color: '#1a1a2e' }}
                        onClick={appointment.appointment_customer_note?.description.length > MAX_LENGTH ? handleToggleExpand : null}
                        style={{ cursor: appointment.appointment_customer_note?.description.length > MAX_LENGTH ? 'pointer' : 'default' }}
                    >
                      {expanded
                        ? appointment.appointment_customer_note?.description
                        : appointment.appointment_customer_note?.description.slice(0, MAX_LENGTH) + (appointment.appointment_customer_note?.description.length > MAX_LENGTH ? '...' : '')}
                    </Typography>
                  </Box>
                )}
              </Grid>

              {/* SERVICES */}
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.25 }}>
                  <Typography sx={{ ...sectionLabel, mb: 0 }}>
                    {appointment?.plan?.id ? 'BUNDLE' : (services.length > 1 ? 'SERVICES' : 'SERVICE')}
                  </Typography>
                  {!appointment?.plan?.id && services.length > 0 && (
                    <Box sx={{
                      background: '#FAEFF5', color: '#A72C68',
                      border: '1px solid #F0CDDB', borderRadius: '999px',
                      px: 1, py: 0.25, fontSize: '11px', fontWeight: 700,
                    }}>
                      {services.length} {services.length === 1 ? 'ITEM' : 'ITEMS'}
                    </Box>
                  )}
                </Box>
                {appointment?.plan?.id ? (
                  <Box sx={{ background: '#F9FAFB', borderRadius: '10px', p: 1.25, border: '1px solid #E5E7EB' }}>
                    <Typography sx={{ fontSize: '11px', color: '#1a1a2e', fontWeight: 600 }}>Bundle #{appointment?.plan?.id}</Typography>
                    <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1a1a2e', mt: 0.25 }}>
                      {appointment?.plan?.title}
                    </Typography>
                    {appointment?.current_session && (
                      <Typography sx={{ fontSize: '12px', color: '#A72C68', fontWeight: 700, mt: 0.5 }}>
                        Session {appointment?.current_session} / {appointment?.plan?.no_of_bookings}
                      </Typography>
                    )}
                  </Box>
                ) : (
                  <Stack spacing={1}>
                    {visibleServices.map((service, i) => (
                      <Box key={i} sx={{
                        background: '#F9FAFB', borderRadius: '10px', p: 1.25,
                        border: '1px solid #E5E7EB',
                      }}>
                        <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#1a1a2e', textTransform: 'capitalize' }}>
                          {service?.name}
                        </Typography>
                        {(service?.sub_name || service?.duration) && (
                          <Typography sx={{ fontSize: '11px', color: '#1a1a2e', mt: 0.25 }}>
                            {service?.sub_name || (service?.duration ? `${service.duration} min` : '')}
                          </Typography>
                        )}
                      </Box>
                    ))}
                    {services.length > 2 && (
                      <Button
                          size="small"
                          onClick={() => setShowAll(!showAll)}
                          sx={{
                            alignSelf: 'flex-start', textTransform: 'none', fontSize: '12px',
                            color: '#A72C68', padding: 0, minWidth: 'auto',
                            '&:hover': { background: 'transparent', textDecoration: 'underline' },
                          }}
                      >
                        {showAll ? 'Show Less' : `+${services.length - 2} more`}
                      </Button>
                    )}
                  </Stack>
                )}
              </Grid>

              {/* SCHEDULE */}
              <Grid item xs={12} sm={6} md={3}>
                <Typography sx={sectionLabel}>SCHEDULE</Typography>
                {appointment?.date ? (
                  <Box sx={{
                    background: '#FAEFF5',
                    border: '1px solid #F0CDDB',
                    borderRadius: '10px',
                    p: 1.5,
                    transition: 'all 0.25s ease',
                    cursor: 'default',
                    '& .schedule-date': { color: '#A72C68' },
                    '& .schedule-time': { color: '#1a1a2e' },
                    '& .schedule-divider': { borderTopColor: '#F0CDDB' },
                    '& .schedule-duration': { color: '#1a1a2e' },
                    '&:hover': {
                      background: 'linear-gradient(135deg,#A72C68 0%,#921F58 100%)',
                      border: '1px solid transparent',
                      boxShadow: '0 4px 12px rgba(167,44,104,0.25)',
                      '& .schedule-date': { color: '#fff' },
                      '& .schedule-time': { color: '#fff' },
                      '& .schedule-divider': { borderTopColor: 'rgba(255,255,255,0.25)' },
                      '& .schedule-duration': { color: 'rgba(255,255,255,0.85)' },
                    },
                  }}>
                    <Typography className="schedule-date" sx={{ fontSize: '14px', fontWeight: 700 }}>
                      {moment(appointment.date).format('MMM D, YYYY')}
                    </Typography>
                    {appointment?.start_time && appointment?.end_time && (
                      <>
                        <Typography className="schedule-time" sx={{ fontSize: '15px', fontWeight: 700, mt: 0.5 }}>
                          {moment(appointment.start_time, 'HH:mm:ss').format('hh:mm')} – {moment(appointment.end_time, 'HH:mm:ss').format('hh:mm A')}
                        </Typography>
                        <Box className="schedule-divider" sx={{ borderTop: '1px dashed #F0CDDB', mt: 1, pt: 0.75 }}>
                          <Typography className="schedule-duration" sx={{ fontSize: '11px', fontStyle: 'italic' }}>
                            {(() => {
                              const start = moment(appointment.start_time, 'HH:mm:ss');
                              const end = moment(appointment.end_time, 'HH:mm:ss');
                              const mins = end.diff(start, 'minutes');
                              const h = Math.floor(mins / 60);
                              const m = mins % 60;
                              return `${h > 0 ? `${h}h ` : ''}${m > 0 ? `${m}m` : ''} duration`.trim();
                            })()}
                          </Typography>
                        </Box>
                      </>
                    )}
                  </Box>
                ) : (
                  <MuiLink href="#" sx={{ fontSize: '14px', color: '#CB3838', textDecorationColor: '#CB3838' }}>
                    Set Date and Time
                  </MuiLink>
                )}
                {appointment?.status !== 'Completed' && appointment?.status !== 'No Show' && appointment?.date && (
                  <Box sx={{ mt: 1 }}>
                    <AppointmentStaffStatus
                        label={"Mark as No Show"} isNoShow value={'No Show'}
                        isFetch fetchAppointment={fetchAppointment}
                        appointment={appointment}
                    />
                  </Box>
                )}
              </Grid>

              {/* AMOUNT */}
              <Grid item xs={12} sm={6} md={3}>
                <Typography sx={sectionLabel}>AMOUNT</Typography>
                <Box sx={{
                  background: '#FAEFF5',
                  border: '1px solid #F0CDDB',
                  color: '#A72C68',
                  borderRadius: '10px',
                  p: 1.5,
                  transition: 'all 0.25s ease',
                  cursor: 'default',
                  '& .total-due-label': { color: '#A72C68', opacity: 0.75 },
                  '& .total-due-divider': { borderTopColor: '#F0CDDB' },
                  '& .total-due-wallet-label': { color: '#1a1a2e' },
                  '& .total-due-wallet-value': { color: '#A72C68' },
                  '&:hover': {
                    background: 'linear-gradient(135deg,#A72C68 0%,#921F58 100%)',
                    border: '1px solid transparent',
                    color: '#fff',
                    boxShadow: '0 4px 12px rgba(167,44,104,0.25)',
                    '& .total-due-label': { color: '#fff', opacity: 0.85 },
                    '& .total-due-divider': { borderTopColor: 'rgba(255,255,255,0.25)' },
                    '& .total-due-wallet-label': { color: 'rgba(255,255,255,0.85)' },
                    '& .total-due-wallet-value': { color: '#fff' },
                  },
                }}>
                  <Typography className="total-due-label" sx={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase' }}>
                    Total Due
                  </Typography>
                  <Typography sx={{ fontSize: '24px', fontWeight: 800, mt: 0.25, lineHeight: 1.1, color: 'inherit' }}>
                    ${appointment?.grand_total ?? '0.00'}
                  </Typography>
                  {appointment?.customer?.wallet_point != null && (
                    <Box className="total-due-divider" sx={{ mt: 0.75, pt: 0.75, borderTop: '1px solid #F0CDDB' }}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>
                        <Box component="span" className="total-due-wallet-label">Wallet: </Box>
                        <Box component="span" className="total-due-wallet-value" sx={{ fontWeight: 800 }}>${appointment?.customer?.wallet_point}</Box>
                      </Typography>
                    </Box>
                  )}
                </Box>
                {appointment?.futurePayment && (
                  <Typography sx={{ mt: 1, fontSize: '12px', color: '#1a1a2e' }}>
                    Future Payment: {appointment?.futurePayment}
                  </Typography>
                )}
                {appointment?.appointment_customer_note?.description && (
                  <Typography sx={{ mt: 1, fontSize: '12px', color: '#1a1a2e', fontStyle: 'italic' }}>
                    Note: {String(appointment.appointment_customer_note.description).slice(0, 40)}
                    {String(appointment.appointment_customer_note.description).length > 40 ? '…' : ''}
                  </Typography>
                )}
                {appointment?.status === 'Completed' && (
                  <Box sx={{ mt: 1 }}>
                    <MuiLink
                        component="button"
                        onClick={() => openInvoicePanel(appointment?.id)}
                        underline="hover"
                        sx={{ fontSize: '12px', color: '#1976D2', display: 'inline-flex', alignItems: 'center', gap: 0.5, background: 'none', border: 'none', cursor: 'pointer', p: 0 }}
                    >
                      <LocalPrintshopOutlinedIcon sx={{ fontSize: 16 }} /> Print Invoice
                    </MuiLink>
                  </Box>
                )}
              </Grid>
            </Grid>
          </Box>

          {/* ── Bottom action bar: icon-only buttons with hover tooltips ──────── */}
          <Box sx={{
            display: { xs: 'grid', sm: 'flex' },
            gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))' },
            alignItems: { xs: 'stretch', sm: 'center' },
            justifyContent: 'flex-start',
            flexWrap: 'wrap',
            gap: 1,
            px: { xs: 1.5, sm: 2.5 },
            py: 1.25,
            width: '100%',
            background: '#FDFBFC',
            borderTop: '1px solid #F0CDDB',
            '& > *': { width: { xs: '100%', sm: 'auto' }, minWidth: 0 },
            '& button': { whiteSpace: { xs: 'normal', sm: 'nowrap' }, lineHeight: 1.25 },
          }}>
            <IconAction tooltip="Book Now" color="#56CCF2">
              <CustomButtoncolor
                  mainColor={"#56CCF2"}
                  size="md"
                  val="Book Now"
                  icon={<EventAvailableIcon />}
                  handleClick={() => {
                    localStorage.setItem("url", pathname);
                    navigate(`/crm/add-appointment/user/${appointment?.customer?.id}`);
                  }}
                  fwidth={'100%'}
                  fsize={'13px'}
                  style={stylebtn}
              />
            </IconAction>

            {appointment?.status !== 'Void' && appointment?.status !== 'Canceled' && appointment?.status !== 'Completed' && appointment?.date && (
              <IconAction tooltip={appointment?.staff?.id ? "Edit Staff" : "Assign Staff"} color="#7986CB">
                <AppointmentStaffStatus
                    isbtn
                    fetchAppointment={fetchAppointment}
                    appointment={appointment}
                    style={stylebtn}
                    fwidth={'100%'}
                    fsize={'13px'}
                />
              </IconAction>
            )}

            {(appointment?.status === 'Pending') && appointment?.date && (
              <IconAction tooltip="Confirm" color="#7986CB">
                <AppointmentStaffStatus
                    isbtn
                    isFetch
                    label={"Confirm"}
                    value={'Confirmed'}
                    mainColor={"#7986CB"}
                    style={buttonStyle}
                    fetchAppointment={fetchAppointment}
                    appointment={appointment}
                    fwidth={'100%'}
                    fsize={'13px'}
                />
              </IconAction>
            )}

            {(appointment?.status === 'Pending' || appointment?.status === 'Confirmed' || appointment?.status === 'No Show') && appointment?.date && (
              <IconAction tooltip="Check-In" color="#F2C94C">
                <AppointmentStaffStatus
                    isbtn
                    isFetch
                    label={"Check-In"}
                    value={'CheckIn'}
                    mainColor={"#F2C94C"}
                    style={stylebtn}
                    fetchAppointment={fetchAppointment}
                    appointment={appointment}
                    fwidth={'100%'}
                    fsize={'13px'}
                />
              </IconAction>
            )}

            {appointment?.status === 'CheckIn' && appointment?.date && (
              <IconAction tooltip="Check-Out" color="#6FCF97">
                <AppointmentStaffStatus
                    isbtn
                    label={"Check-Out"}
                    value={'CheckOut'}
                    mainColor={"#6FCF97"}
                    fetchAppointment={fetchAppointment}
                    appointment={appointment}
                    style={stylebtn}
                    fwidth={'100%'}
                    fsize={'13px'}
                />
              </IconAction>
            )}

            {appointment?.status !== 'Void' && appointment?.status !== 'Canceled' && appointment?.status !== 'Completed' && (
              <IconAction tooltip="Reschedule" color="#BB6BD9">
                <AppointmentReschedule isAppointment appointment={appointment} fwidth={'100%'} fsize={'13px'} />
              </IconAction>
            )}

            {appointment?.status !== 'Void' && appointment?.status !== 'Canceled' && appointment?.status !== 'Completed' && (
              <IconAction tooltip="Edit Appointment" color="#5C6BC0">
                <CustomButtoncolor
                    mainColor={"#5C6BC0"}
                    handleClick={() => handleEditReschedule(navigate, appointment)}
                    val={"Edit Appointment"}
                    icon={<EditCalendarIcon />}
                    style={stylebtn}
                    fwidth={'100%'}
                    fsize={'13px'}
                    paddin={"10px 5px !important"}
                />
              </IconAction>
            )}

            <IconAction tooltip="Notes" color="#BA68C8">
              <CustomButtoncolor
                  handleClick={() => handleAppointmentClick(`/crm/customer-relationship-management/customer/notes/${appointment?.customer?.id}`)}
                  mainColor={"#BA68C8"}
                  style={stylebtn}
                  val={"Notes"}
                  icon={<NoteAltIcon />}
                  fwidth={'100%'}
                  fsize={'13px'}
              />
            </IconAction>

            <IconAction tooltip="Attachments" color="#D4A373">
              <CustomButtoncolor
                  handleClick={() => handleAppointmentClick(`/crm/appointment/attachments/${appointment?.id}`)}
                  mainColor={"#D4A373"}
                  style={stylebtn}
                  val={"Attachments"}
                  icon={<AttachFileIcon />}
                  fwidth={'100%'}
                  fsize={'13px'}
              />
            </IconAction>

            <IconAction tooltip="Send Email" color="#D08CAA">
              <SetEmailModal
                  styles={{ fontSize: "15px" }}
                  customer_id={appointment?.customer?.id}
              />
            </IconAction>

            {appointment?.status !== 'Void' && appointment?.status !== 'Canceled' && appointment?.status !== 'Completed' && appointment?.date && (
              <IconAction tooltip="Cancel/Refund" color="#EF7B7B" sx={{ '& button': { width: '100%', minWidth: 0, maxWidth: '100%', boxSizing: 'border-box', whiteSpace: 'normal', overflowWrap: 'anywhere', px: '8px' } }}>
                <AppointmentStaffStatus
                    isbtn
                    isFetch
                    label={"Cancel/Refund"}
                    value={'Canceled'}
                    mainColor={"#EF7B7B"}
                    fetchAppointment={fetchAppointment}
                    appointment={appointment}
                    style={stylebtn}
                    fwidth={'100%'}
                    fsize={'13px'}
                />
              </IconAction>
            )}

            <IconAction tooltip="Treatment Form" color="#4DB6AC">
              <TreatmentFormButton fwidth={'100%'} data={appointment} fsize={'17px'} />
            </IconAction>

            <IconAction tooltip="Booking History" color="#5C6BC0">
              <CustomButtoncolor
                  handleClick={() => handleAppointmentClick(`/crm/appointment/history/${appointment?.id}`)}
                  mainColor={"#5C6BC0"}
                  style={stylebtn}
                  val={"Booking History"}
                  icon={<HistoryIcon />}
                  fwidth={'100%'}
                  fsize={'13px'}
              />
            </IconAction>

            <IconAction tooltip="Booking Details" color="#26A69A">
              <CustomButtoncolor
                  handleClick={() => handleAppointmentClick(`/crm/appointment/details/${appointment?.id}`)}
                  mainColor={"#26A69A"}
                  style={stylebtn}
                  val={"Booking Details"}
                  icon={<InfoOutlinedIcon />}
                  fwidth={'100%'}
                  fsize={'13px'}
              />
            </IconAction>
          </Box>

          {/* Invoice side panel — slide-in from right, mirrors calendar pattern */}
          <Dialog
            open={invoicePanelBookingId !== null}
            onClose={() => setInvoicePanelBookingId(null)}
            maxWidth={false}
            sx={{
                '& .MuiDialog-container': {
                    justifyContent: 'flex-end',
                    alignItems: 'flex-start',
                    padding: { xs: 0, md: '12px 12px 12px 0' },
                },
            }}
            PaperProps={{
                sx: {
                    width: { xs: '100vw', sm: '90vw', md: '700px', lg: '780px' },
                    height: { xs: '100vh', md: 'calc(100vh - 24px)' },
                    maxHeight: { xs: '100vh', md: 'calc(100vh - 24px)' },
                    borderRadius: { xs: 0, md: '16px' },
                    overflow: 'hidden',
                    m: 0,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                    display: 'flex',
                    flexDirection: 'column',
                    background: '#fff',
                },
            }}
          >
            <Box sx={{
                display: 'flex', alignItems: 'center', px: 2.5, py: 1.5,
                borderBottom: '1px solid #f3f4f6', flexShrink: 0, background: '#fff', gap: 1,
            }}>
                <Tooltip title="Back" placement="bottom">
                    <IconButton size="small" onClick={() => setInvoicePanelBookingId(null)} sx={{ color: '#9ca3af', borderRadius: '8px', '&:hover': { color: '#A72C68', background: '#FAEFF5' } }}>
                        <ArrowBackIcon sx={{ fontSize: 17 }} />
                    </IconButton>
                </Tooltip>
                <Typography sx={{ flex: 1, fontWeight: 700, fontSize: '15px', color: '#111827', fontFamily: 'helvetica-lt-std-bold,sans-serif' }}>
                    Invoice #{invoicePanelBookingId}
                </Typography>
                <Tooltip title="Close" placement="bottom">
                    <IconButton size="small" onClick={() => setInvoicePanelBookingId(null)} sx={{ color: '#9ca3af', borderRadius: '8px', '&:hover': { color: '#ef4444', background: '#fef2f2' } }}>
                        <CloseIcon sx={{ fontSize: 17 }} />
                    </IconButton>
                </Tooltip>
            </Box>
            <Box sx={{
                flex: 1, overflowY: 'auto', background: '#f9fafb',
                '&::-webkit-scrollbar': { width: '8px' },
                '&::-webkit-scrollbar-track': { background: '#FAEFF5', borderRadius: '8px' },
                '&::-webkit-scrollbar-thumb': { background: '#A72C68', borderRadius: '8px', border: '2px solid #FAEFF5' },
                '&::-webkit-scrollbar-thumb:hover': { background: '#921F58' },
            }}>
                {invoicePanelBookingId && <InvoicesPanel booking_id={invoicePanelBookingId} panelMode />}
            </Box>
          </Dialog>
        </Box>

      );
  };

  export default CardAppointment;
